import { parseError } from './parseError';
import { TestResult, TestStep } from '@playwright/test/reporter';

type NestedStepT = {
  number: number;
  title: string;
  status: 'passed' | 'failed';
  error: TestStep['error'];
  category: string;
  location: TestStep['location'];
  steps: NestedStepT[];
};

export function parseNestedSteps(steps: TestResult['steps']): NestedStepT[] {
  if (!steps || steps.length === 0) {
    return [];
  }

  return steps.map((step: TestStep, index: number) => ({
    number: index + 1,
    title: step.title,
    status: step.error ? 'failed' : 'passed',
    error: step.error ? parseError(step.error) : step.error,
    category: step.category,
    location: step.location,
    duration: step.duration,
    startTime: step.startTime,
    steps: parseNestedSteps(step.steps),
  }));
}
